import { createNamespacedHelpers } from 'vuex'
import { ELECTRONICBANK } from '../interface/electronicBank'
import { merge } from 'lodash'

const initState = {
  guarantee: {},
  edit: {},
}

const mutations = {
  [ELECTRONICBANK.GUARANTEE](state, paylod) {
    state.guarantee = merge(state.guarantee, paylod)
  },
  [ELECTRONICBANK.CLEAR](state) {
    state.guarantee = {}
  },
  [ELECTRONICBANK.SET_EDIT_ID](state, id) {
    state.edit.id = id
  },
}

const { mapMutations, mapState } = createNamespacedHelpers('electronicBank')

export { mapMutations, mapState, ELECTRONICBANK }

export default {
  namespaced: true,
  state: initState,
  mutations: mutations,
}
